import { NewDollorIcon } from '@/src/assets/icons'
import { Tooltip, Typography } from '@mui/material'

interface Props {
  data: any
}

const AnnouncementMultiLabels = ({ data }: Props) => {
  const getSortedData = (items: any) => {
    items.sort((a: any, b: any) => a.toLowerCase().localeCompare(b.toLowerCase()))

    const index = items.indexOf('Presentation')

    if (index !== -1) {
      const presentationItem = items.splice(index, 1)[0]
      items.push(presentationItem)
    }

    return items
  }

  return (
    <>
      {(() => {
        const icons: JSX.Element[] = []
        const texts: JSX.Element[] = []

        getSortedData(data?.length ? data : [])?.map((d: string, index: number) => {
          if (d === 'Price Sensitive') {
            icons.push(
              <Tooltip key={`icon-${index}`} title="Price Sensitive">
                <div className="flex gap-1">
                  <NewDollorIcon className="w-5 h-5 fill-primary-main cursor-pointer" />
                </div>
              </Tooltip>
            )
          } else if (d === 'Annual Report' || d === 'Annual Reports') {
            texts.push(
              <div key={`text-${index}`}>
                <Typography
                  variant="chipLabel"
                  className="bg-secondary-gray text-center rounded-md px-2 py-0.5 w-28"
                >
                  Company Report
                </Typography>
              </div>
            )
          } else {
            texts.push(
              <div key={`text-${index}`}>
                <Typography
                  variant="chipLabel"
                  className="bg-secondary-gray text-center rounded-md px-2 py-0.5 w-28"
                >
                  {d}
                </Typography>
              </div>
            )
          }
        })

        return (
          <div className="cursor-pointer flex items-center gap-1 flex-wrap">
            {icons}
            {texts}
          </div>
        )
      })()}
    </>
  )
}

export default AnnouncementMultiLabels
